"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TILE_CURSOR = exports.AVATAR = exports.FURNITURE = void 0;
exports.FURNITURE = Symbol("FURNITURE");
exports.AVATAR = Symbol("AVATAR");
exports.TILE_CURSOR = Symbol("TILE_CURSOR");
